module.exports = __webpack_public_path__ + "static/media/Img_card_PP.1ce962be.jpg";